import styled from 'styled-components'
import { Text, truncateLines } from '@sketch/components'

export const Container = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  width: 100%;
`

export const NameSkeleton = styled(Text)`
  color: ${({ theme }) => theme.colors.foreground.secondary.A};
  font-size: ${({ theme }) => theme.fontSizes.F};
  font-weight: ${({ theme }) => theme.fontWeights.semibold};

  ${truncateLines(1)}

  margin-top: 10px; /* stylelint-disable-line scales/space */
  width: 40%;
  display: inline-block;
  background-color: ${({ theme }) => theme.colors.background.secondary.B};
  border-radius: ${({ theme }) => theme.radii.xlarge};

  ::after {
    /* Have some dummy text to fill the height */
    content: 'a';
    opacity: 0;
  }
`
